import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!url || !anon) {
  // eslint-disable-next-line no-console
  console.warn(
    "[supabase] VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY missing. " +
      "Public reads will fail. Set them in .env.local."
  );
}

export const supabase = createClient(url ?? "http://invalid.local", anon ?? "anon", {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storageKey: "weldquest.auth",
  },
  db: { schema: "public" },
  global: {
    headers: { "x-client-info": "weldquest-web" },
  },
});

export const SUPABASE_URL = url ?? "";
export const SUPABASE_ANON_KEY = anon ?? "";
